export enum Platform {
    Mac = 'mac',
    Ios = 'ios',
    tvOS = 'tvos',
}
